import { Loader, Box, Inline } from 'braid-design-system';

export const Loading = () => (
  <Box paddingY="xlarge" paddingX={{ mobile: 'medium', tablet: 'gutter' }}>
    <Inline align="center" space="medium">
      <Loader />
    </Inline>
  </Box>
);

export default Loading;
